@if (collection.data.length == 0 && isProcessed) {
  <div class="row margin-top-100 margin-bottom-100">
    <div class="col-sm-12 text-center">
      <h3>Oops!</h3>
      <p>
        Properties could not be found. Please try a different search.
      </p>
    </div>
  </div>
}
@if (collection.data.length > 0) {
  <div id="container-listing" class="container margin-top-20">
    <div class="row fullwidth-layout">
      <div class="col-md-12">
        <!-- Listings -->
        <div class="listings-container list-layout">
          @for (item of collection.data | paginate: config; track item) {
            <div class="listing-item">
              <div class="listing-img-container" (click)="showSlider(item)">
                <div class="listing-badges">
                  <span>{{item.Type}} For {{item.Purpose}}</span>
                </div>
                <div class="listing-img-content">
                  <span class="listing-price">PKR {{item.Price}} <i>{{item.AreaUnit}}</i></span>
                </div>
                <div class="listing-carousel">
                  <img [src]="item.ImageUrl" alt="" />
                </div>
                <div class="total-pictures-count">
                  <i class="fa fa-picture-o" aria-hidden="true"></i>
                  {{item.Images.length}}
                </div>
              </div>
              <div class="listing-content">
                <div class="listing-title padding-bottom-0 padding-top-0">
                  <h4 class="text-truncate">
                    <a [routerLink]="['/property', item.PropertyUrl]" attr.aria-label="{{item.Title}}">{{item.Title}}</a>
                  </h4>
                </div>
                <div class="listing-title padding-top-5 description hidden-xs">
                  <h5 class="text-truncate">
                    <a [routerLink]="['/property', item.PropertyUrl]" attr.aria-label="{{item.Description}}" class="listing-address popup-gmaps text-truncate">
                      <div [innerHTML]="item?.PlainTextDescription" ></div>
                    </a>
                  </h5>
                </div>
                <div class="listing-title custom-title padding-bottom-0 padding-top-0">
                  <h5 class="text-truncate margin-bottom-0">
                    <a [routerLink]="['/property', item.PropertyUrl]" attr.aria-label="{{item.Location}}" class="listing-address popup-gmaps text-truncate">
                      <i class="fa fa-map-marker"></i>
                      {{item.Location}}
                    </a>
                  </h5>
                  <a [routerLink]="['/property', item.PropertyUrl]" attr.aria-label="Property Details" class="details button border margin-top-20">Details</a>
                </div>
                <div class="row listing-features  margin-left-0">
                  @if (item.BedRooms != '') {
                    <div class="padding-left-custom col-md-2 col-sm-3 col-xs-3">
                      <ul class="padding-left-0">
                        <li><span><i class="fa fa-bed"></i>&nbsp;&nbsp;{{item.BedRooms}}</span></li>
                      </ul>
                    </div>
                  }
                  @if (item.BathRooms != '') {
                    <div class="padding-left-custom col-md-2 col-sm-3 col-xs-3">
                      <ul class="padding-left-0">
                        <li>
                          <div class="img-bath-room"></div><span>&nbsp;&nbsp;&nbsp;{{item.BathRooms}}</span>
                        </li>
                      </ul>
                    </div>
                  }
                  <div class="col-md-8 col-sm-6 col-xs-6 text-truncate padding-left-custom">
                    <span class="prop-length">
                      <div class="img-compass"></div><span class="padding-left-20">{{item.AreaUnit}}</span>
                    </span>
                  </div>
                </div>
                <div class="listing-footer">
                  <a href="javascript:void();"><i class="fa fa-user"></i> {{item.UserName}}</a>
                  <a href="javascript:void();" class="pull-right"><i class="fa fa-calendar-o"></i> {{item.PublishDate}}</a>
                </div>
              </div>
            </div>
          }
        </div>
        <!-- Listings Container / End -->
        <div class="clearfix"></div>
        <!-- Pagination -->
        <pagination-template #p="paginationApi" [id]="config.id" (pageChange)="config.currentPage = $event">
          <div class="pagination-container margin-top-20">
            <nav class="pagination">
              <ul>
                @for (page of p.pages; track page) {
                  <li>
                    &nbsp;<a href="javascript:void(0);" [class.current-page]="p.getCurrent() === page.value"
                  (click)="p.setCurrent(page.value);bindListingEvents();">{{ page.label }}</a>&nbsp;
                </li>
              }
            </ul>
          </nav>
          <nav class="pagination-next-prev">
            <ul>
              <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
                <li>
                  @if (!p.isFirstPage()) {
                    <a href="javascript:void(0);" class="prev"
                    (click)="p.previous();bindListingEvents();">Previous</a>
                  }
                </li>
              </div>
              <div class="pagination-next" [class.disabled]="p.isLastPage()">
                <li>
                  @if (!p.isLastPage()) {
                    <a href="javascript:void(0);" class="next"
                    (click)="p.next();bindListingEvents();">Next</a>
                  }
                </li>
              </div>
            </ul>
          </nav>
        </div>
      </pagination-template>
    </div>
  </div>
</div>
}

@if (IsLoading) {
  <div class="spinnerPlacement">
    <app-spinner></app-spinner>
  </div>
}
<div id="dynamicLightGallery"></div>
